import BaseService from "./BaseService.js";

class CaddService extends BaseService {
  submitAdditionalInformation(payload) {
    return this.apiPost({
      url: "/profile/additional-information",
      data: payload,
    });
  }
}

export default new CaddService();
